<template>
  <ServicePageLayout
    title="HVAC"
    subtitle="ระบบปรับอากาศ"
    icon="mdi-hvac"
    icon-color="secondary"
    breadcrumb="Operations"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>Plant</v-tab>
      <v-tab>Chiller</v-tab>
      <v-tab>Machine</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><HVAC_PLANT /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><CHILLER_LIST /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><MACHINE_VIEW :assets="hvac_machine" /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import MACHINE_VIEW from '@/components/machine/machine_view'
import HVAC_PLANT from '@/components/hvac/hvac_plant.vue'
import CHILLER_LIST from '@/components/hvac/chiller_list.vue'

export default {
  name: 'HVACView',
  components: {
    ServicePageLayout,
    MACHINE_VIEW,
    HVAC_PLANT,
    CHILLER_LIST
  },
  data() {
    return {
      tab: null,
    }
  },
  computed: {
    hvac_machine() {
      return this.$store.state.Asset.assetAll.filter(
        el => el.machine === true && el.serviceId === '5b3c30a7-978d-45e0-beda-0a1bf7ba8048'
      )
    }
  },
}
</script>
